// TODO: address typings later. Don't bring tslib@1.14.x
/* eslint-disable @typescript-eslint/no-explicit-any */
import { featureEnabler } from './feature-enabler';

export interface SentryConfig {
  dsn: string;
  applicationName: string;
  clientVersion: string;
  partnerId: string;
}

const FF_SENTRY = 'sentryLogger';
/**
 * Logger to sent performance data to SentryIo
 */
export class SentryDebugLog {
  public static sentryInstance: any;

  /**
   * Needed to provide user info if needed
   * @param user
   */
  public static updateSentryUser(user: any) {
    SentryDebugLog.sentryInstance.setUser(user);
  }

  /**
   * Example: await new SentryDebugLog().init(Sentry)
   *
   * To init logger with existing Sentry instance, just pass it as param sentryInstance;
   * @param sentryInstance
   */
  public async init(sentryInstance: any /*typeof Sentry*/) {
    SentryDebugLog.sentryInstance = sentryInstance;
  }
}

export const sentryDebugLog = new SentryDebugLog();

/**
 * Decorator to log async transactions
 * @param className
 */
export function asyncSentryLogger(className?: string) {
  return (
    target: any,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<(...params: any[]) => Promise<any>>,
  ) => {
    const oldFunc = descriptor.value;
    descriptor.value = async function (...args) {
      const isEnabled = featureEnabler.variation(FF_SENTRY, false);
      if (!isEnabled || !SentryDebugLog.sentryInstance) {
        return await oldFunc?.apply(this, args);
      }
      try {
        const transaction = SentryDebugLog.sentryInstance.startTransaction({ name: `${className}.${propertyKey}` });
        // @ts-expect-error TODO Fix
        SentryDebugLog.sentryInstance.getCurrentHub().configureScope((scope) => scope.setSpan(transaction));
        // @ts-expect-error TODO Fix
        SentryDebugLog.sentryInstance.configureScope((scope) => {
          scope.setTag('logType', 'asyncMethodDecorator');
          scope.setTag('className', className);
          scope.setTag('methodName', propertyKey);
        });

        const result = await oldFunc?.apply(this, args);
        transaction.finish();
        return result;
      } catch (e) {
        /* empty */
      }
    };
  };
}
